import * as React from 'react';
import Callout from '../site/Callout';
import { IVorgang, IMeta } from '../../models/ApiTypes';

interface IVorgangUebermittlungInfoProps {
  vorgang: IVorgang;
}

export default class VorgangUebermittlungInfo extends React.Component<IVorgangUebermittlungInfoProps, {}> {

  private getMeta(bezeichnung: string) {
    const { vorgang } = this.props;
    return (vorgang && vorgang.meta && vorgang.meta.find(meta => meta.bezeichnung === bezeichnung));
  }

  render() {
    // Wenn die Daten übermittelt wurden, wird im Vorgang ein Metadatum mit DocID als Markierung gespeichert
    let metaDatenuebermittlung: IMeta | undefined = this.getMeta('letzte_docid');

    return (
      <Callout bsStyle="success">
        <h4 style={{marginBottom: 'inherit'}}>Daten wurden übermittelt</h4>
        {metaDatenuebermittlung && <p>Die von Ihnen erfassten Daten wurden erfolgreich am <b>{metaDatenuebermittlung.zeitpunkt}</b> unter dem Aktenzeichen <b>{metaDatenuebermittlung.inhalt}</b> an die DIQ Zert GmbH übermittelt.</p>}
        {!metaDatenuebermittlung && <p>Die von Ihnen erfassten Daten wurden erfolgreich an die DIQ Zert GmbH übermittelt.</p>}
        <p>Die gültigen Dokumente werden nach Prüfung im Auftrag als freigegebene Dokumente zur Verfügung gestellt.</p>
      </Callout>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/VorgangUebermittlungInfo.tsx